import React, { useEffect, createElement } from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { PainSection } from '../components/sales/PainSection';
import { MechanismSection } from '../components/sales/MechanismSection';
import { OfferSection } from '../components/sales/OfferSection';
import { TestimonialsSection } from '../components/sales/TestimonialsSection';
import { FAQSection } from '../components/sales/FAQSection';
import { GuaranteeSection } from '../components/sales/GuaranteeSection';
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: unknown;
  }
}
export function SalesPage() {
  useEffect(() => {
    // Inject Meta Pixel
    if (typeof window.fbq === 'function') return; // already loaded
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    (function () {
      const fbq: ((...args: unknown[]) => void) & {
        callMethod?: (...args: unknown[]) => void;
        queue: unknown[];
        loaded: boolean;
        version: string;
        push?: (...args: unknown[]) => void;
      } = function (...args: unknown[]) {
        if (fbq.callMethod) {
          fbq.callMethod(...args);
        } else {
          fbq.queue.push(args);
        }
      };
      fbq.queue = [];
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.push = fbq;
      window.fbq = fbq;
      if (!window._fbq) window._fbq = fbq;
    })();
    window.fbq('init', '1136780540633633');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-258">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-259">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1136780540633633&ev=PageView&noscript=1" alt="" data-id="element-260" />
      </noscript>

      {/* Header */}
      <header className="absolute top-0 w-full z-50 py-4 px-6" data-id="element-261">
        <div className="container mx-auto flex justify-between items-center" data-id="element-262">
          <div className="text-xl font-bold text-primary font-serif tracking-tight" data-id="element-263">
            Pies Sin Presión
          </div>
        </div>
      </header>

      <main data-id="element-264">
        <HeroSection data-id="element-265" />
        <PainSection data-id="element-266" />
        <MechanismSection data-id="element-267" />
        <OfferSection data-id="element-268" />
        <TestimonialsSection data-id="element-269" />
        <FAQSection data-id="element-270" />
        <GuaranteeSection data-id="element-271" />
      </main>

      <footer className="bg-gray-900 text-gray-400 py-12" data-id="element-272">
        <div className="container mx-auto px-4 text-center" data-id="element-273">
          <p className="mb-4" data-id="element-274">
            &copy; {new Date().getFullYear()} Pies Sin Presión. Todos los
            derechos reservados.
          </p>
          <div className="flex justify-center space-x-6 text-sm" data-id="element-275">
            <a href="#" className="hover:text-white transition-colors" data-id="element-276">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-277">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-278">
              Contacto
            </a>
          </div>
          <p className="mt-8 text-xs text-gray-600 max-w-2xl mx-auto" data-id="element-279">
            Este producto no sustituye el consejo médico profesional. Si tiene
            una condición médica grave, consulte a su médico antes de usar. Los
            resultados pueden variar de persona a persona.
          </p>
        </div>
      </footer>
    </div>;
}